import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  position: relative;
  outline: none;
  padding: 4px 3px;
  margin: 0;
  height: 17px;
  width: 17px;
  background-color: #eaeaea;
  border: 1px solid #306ba5;
  color: #306ba5;
  display: flex;
  place-items: center;
  cursor: normal;

  @media screen and (min-width: ${DESKTOP}px) {
    cursor: pointer;
  }
`;
